export var ReviewStatus;
(function (ReviewStatus) {
    ReviewStatus["ACTIVE"] = "ACTIVE";
    ReviewStatus["INACTIVE"] = "INACTIVE";
    ReviewStatus["PENDING"] = "PENDING";
})(ReviewStatus || (ReviewStatus = {}));
//# sourceMappingURL=review-status.enum.js.map